export const ROLES = {
    manager: 'MANAGER',
    tracking: 'TRACKING',
    bookKeeper: 'BOOK_KEEPER',
    accountant: 'ACCOUNTANT'
}


// WEBPACK FOOTER //
// ./src/app/contants/ROLES.ts